import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'

interface MobileSideBarStore {
  isMobileSideBarOpen: boolean
  toggleMobileSideBar: () => void
}

export const useMobileSideBarStore = create<MobileSideBarStore>()(
  immer((set) => ({
    isMobileSideBarOpen: false,
    toggleMobileSideBar: () =>
      set((draft) => {
        draft.isMobileSideBarOpen = !draft.isMobileSideBarOpen
      }),
  }))
)
